import { Card, Col, Layout, Row, Skeleton, theme, Typography } from "antd";
import React, { useRef } from "react";
import {
  initInstitutionSlice,
  initLogSlice,
  setPropertiesInstitution,
  updateInstitution,
} from "../Slices/Log.slice";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import routes from "../../../engine/routes";
import { institutionsDetailinputs } from "./InstitutionDetailForm";
import ReactJson from "react-json-view";
import dayjs from "../../../utils/dayjs";
import { daysJsFormat } from "../../../utils/constants";

const { Content, Sider, Header, Footer } = Layout;

export function LogDetail({ unitId, expanded, onClose }) {
  const { log, loading } = useSelector(state => state.log);

  const { init, clear } = initLogSlice({});

  const {
    baseUrl,
    route,
    method,
    user,
    userAgent,
    ipAddress,
    content,
    entityId,
    params,
    query,
    createdAt = "",
    json,
  } = log;


  return (
    <>
      <Typography.Title level={3} className={""}>
        {routes.logs().detail.title} -{" "}
        {dayjs(createdAt).format(daysJsFormat.fullMs)}
      </Typography.Title>
      {loading ? (
        <Skeleton active />
      ) : (
        <>
          <div>
            <>
              <Card title={<h4>Informations</h4>}>
                <Row gutter={[16, 16]}>
                  <Col span={8}>
                    <h4>Ressources</h4>
                    <span>{baseUrl}</span>
                  </Col>
                  <Col span={8}>
                    <h4>Méthode</h4>
                    <span>{method}</span>
                  </Col>
                  <Col span={8}>
                    <h4>Route</h4>
                    <span>{route}</span>
                  </Col>
                  <Col span={8}>
                    <h4>Utilisateur</h4>
                    <Link to={routes.user(user?._id).detail}>
                      {user?.description?.lastname}{" "}
                      {user?.description?.firstname}
                      <br />
                      {user?.email}
                    </Link>
                  </Col>
                  <Col span={8}>
                    <h4>Navigateur</h4>
                    <p>{userAgent}</p>
                  </Col>
                  <Col span={8}>
                    <h4>Adresse IP</h4>
                    <span>{ipAddress}</span>
                  </Col>{" "}
                  <Col span={8}>
                    <h4>Entitée ID</h4>
                    <span>{entityId}</span>
                  </Col>
                  <Col span={8}>
                    <h4>Queries</h4>
                    <span>
                      <ReactJson
                        src={query || {}}
                        collapsed={true}
                        displayArrayKey={false}
                        displayDataTypes={false}
                      />
                    </span>
                  </Col>
                  <Col span={8}>
                    <h4>Params</h4>
                    <span>
                      <ReactJson
                        src={params}
                        collapsed={true}
                        displayArrayKey={false}
                        displayDataTypes={false}
                      />
                    </span>
                  </Col>
                </Row>
              </Card>
              <br />
              <Row>
                <Col span={24}>
                  <Card title={<h4>Contenu du log</h4>}>
                    <ReactJson
                      src={json}
                      collapsed={true}
                      displayArrayKey={false}
                      displayDataTypes={false}
                    />
                  </Card>
                </Col>{" "}
              </Row>
            </>
          </div>
        </>
      )}
    </>
  );
}
